import { useState } from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { usePermission } from '@/permissions/usePermission';
import { Tabs, type TabItem } from '@/components/common/Tabs';
import { LoginOverviewModal } from '@/features/tenant/loginOverview/LoginOverviewModal';
import { TradingVolumeTab } from './TradingVolumeTab';
import { MarInstrumentsTab } from './MarInstrumentsTab';
import { NotificationsTab, type JumpPayload } from './NotificationsTab';
import { MarketAbusePermissions as P } from './permissions';

export function MarketAbusePage() {
  const can = usePermission();
  const canTv = can(P.tradingVolumeTab);
  const canMar = can(P.marInstrumentsAndNotificationsTab);
  const canConsolidated = can(P.consolidatedView);

  const tabs: TabItem[] = [
    canTv && { key: 'trading-volume', title: 'Trading Volume' },
    canMar && { key: 'mar-instruments', title: 'MAR Instruments' },
    canMar && { key: 'notifications', title: 'Notifications' },
  ].filter(Boolean) as TabItem[];

  const [active, setActive] = useState(tabs[0]?.key ?? 'trading-volume');
  const [jump, setJump] = useState<JumpPayload | null>(null);
  const [loModal, setLoModal] = useState<{ login: number; connector: number } | null>(null);

  const onJump = (symbol: string, firstNotificationDate: string | null) => {
    setJump({ symbol, startDate: firstNotificationDate ?? '' });
    setActive('notifications');
  };

  return (
    <div className="market-abuse-page">
      <PageHeader title="Market Abuse" breadcrumb={['Home', 'Market Abuse']} />
      <div className="card custom-card mb-2">
        <div className="card-header p-0"><Tabs tabs={tabs} active={active} onChange={setActive} variant="underline" /></div>
        <div className="card-body">
          {active === 'trading-volume' && <TradingVolumeTab canConsolidated={canConsolidated} onOpenLogin={(login, connector) => setLoModal({ login, connector })} />}
          {active === 'mar-instruments' && <MarInstrumentsTab onJump={onJump} />}
          {active === 'notifications' && <NotificationsTab jump={jump} onOpenLogin={(login, connector) => setLoModal({ login, connector })} />}
        </div>
      </div>

      {loModal && <LoginOverviewModal login={loModal.login} connector={loModal.connector} onClose={() => setLoModal(null)} />}
    </div>
  );
}
